const ValidationErrorLevels = {
  ERROR: "error",
  WARNING: "warning"
} as const;

const ALL = Object.values(ValidationErrorLevels);

export default { ...ValidationErrorLevels, ALL };
